import React from 'react';
import * as Yup from 'yup';

import { ApplicationFlow } from '../components';
import { documentTypes } from '../data';


const Description = () => (
  <React.Fragment>
    <p>
      A corporation is a company or group of people or an organisation authorized to act as a single entity (legally a person) and recognized as such in law.
    </p>
  </React.Fragment>
);


const fieldSets = [
  {
    legend: 'Corporation Information',
    fields: new Map([
      ['orgName', {
        label: 'Corporation Name',
        title: 'Please provide a valid corporation name',
        'data-help-title': 'Corporation Name',
        'data-help-text': 'Please enter the name of the corporation.',
        validation: Yup.string().required('Please provide a valid corporation name'),
      }],
      ['dba', {
        'data-help-text': 'Please enter the trade name of the corporation.',
      }],
    ]),
  },
  {
    legend: 'Primary Officer Information',
    fields: new Map([
      ['firstName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['middleName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['lastName', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['socialSecurity', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['verifySocialSecurity', {
        'data-help-title': 'Principal Officer',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['title', {
        label: 'Business Title',
        placeholder: 'Mangaing Member',
        'data-help-title': 'Mangaing Member',
        'data-help-text': 'Principal/Highest ranking officer.',
      }],
      ['suffix', {
        initial: 'DDS',
      }],
    ]),
  },
  {
    legend: 'Business Address',
    fields: new Map([
      ['businessAddress'],
      ['businessCity'],
      ['businessState'],
      ['businessZip'],
      ['businessCounty'],
      ['mailingAddressDiff'],
    ]),
  },
  {
    legend: 'Business Information',
    fields: new Map([
      ['businessIncCountry',{
        label: 'Where was the LLC organized?',
      }],
      ['businessApplyReason'],
      ['businessActivity'],
      ['businessServices'],
      ['commonQuestionOne'],
      ['commonQuestionTwo'],
      ['commonQuestionThree'],
      ['commonQuestionFour'],
      ['businessAppliedBefore'],
      ['businessHireEmployees'],
    ]),
  },
  {
    legend: 'Business Dates',
    fields: new Map([
      ['businessDateStart'],
      ['businessClosingMonth'],
    ]),
  },
  {
    legend: 'Contact Information',
    fields: new Map([
      ['customerContactPhone'],
      ['customerContactEmail'],
      ['customerContactEmailVerify',{
        label: 'Verify Contact E-mail'
      }],
    ]),
  },
];


const CorporationApplicationPage = props => (
  <ApplicationFlow
    step={2}
    title="Corporation Application"
    documentType={documentTypes.CORPORATION}
    description={Description}
    fieldSets={fieldSets}
    {...props}
  />
);

export default CorporationApplicationPage;



// WEBPACK FOOTER //
// ./src/pages/corporation-application.js